export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/customerPrize/query`,
          data
        });
      },
      list(data){
          return http.json({
              url: `/customerPrize/list`,
              data
          });
      },
      getByExchangeCode(data){
          return http.json({
              url: `/customerPrize/getByExchangeCode?exchangeCode=${data.code}`
          });
      },
      exchange(data){
          return http.json({
              url: `/customerPrize/exchange?id=${data.id}`
          });
      },

      getInfo(data){
          return http.json({
              url: `/customerPrize/get?id=${data.id}`
          });
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/winPrize.js